import { Tooltip } from '@bryntum/schedulerpro';
import { useEffect } from 'react';
import { SchedulerReference } from '../../types';

export const useTaskIntensityTooltip = (ref: SchedulerReference): void => {
  useEffect(() => {
    const tooltip = new Tooltip({
      forSelector: '.intensity-bar',
      getHtml: (params) => {
        const { event } = params;
        const number = event.target?.getAttribute('data-task-number');

        return number ? `Number of tasks assigned: ${number}` : null;
      },
      hoverDelay: 800,
      hideDelay: 100,
    });

    return () => {
      tooltip.destroy();
    };
  }, [ref]);
};
